import React from "react";
import { useNavigate } from "react-router-dom";
import { Phone, MessageCircle, Calculator } from "lucide-react";
import { navData } from "../../data/mockData";
import { scrollToSection } from "../../lib/scrollToSection";

// Mobile-only sticky action bar: call, WhatsApp, quote.
const MobilePhoneButton = ({ phoneLink }) => {
  const navigate = useNavigate();
  const goToQuote = () => {
    navigate("/#quote-section");
    scrollToSection("quote-section");
  };
  const item = "flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-xs font-semibold transition-colors";

  return (
    <>
      <div className="h-16 md:hidden" aria-hidden="true" />
      <nav
        aria-label="Quick contact"
        className="fixed inset-x-0 bottom-0 z-40 flex border-t border-slate-200 bg-white/95 shadow-[0_-4px_16px_rgba(15,23,42,0.08)] backdrop-blur md:hidden"
        data-testid="mobile-action-bar"
      >
        <a href={`tel:${phoneLink}`} className={`${item} text-slate-700 hover:text-sky-600`} data-testid="mobile-bar-call">
          <Phone className="h-5 w-5" /> Call
        </a>
        <a href={navData.whatsappLink} target="_blank" rel="noopener noreferrer" className={`${item} text-slate-700 hover:text-green-600`} data-testid="mobile-bar-whatsapp">
          <MessageCircle className="h-5 w-5" /> WhatsApp
        </a>
        <button type="button" onClick={goToQuote} className={`${item} bg-sky-600 text-white hover:bg-sky-700`} data-testid="mobile-bar-quote">
          <Calculator className="h-5 w-5" /> Get a Quote
        </button>
      </nav>
    </>
  );
};

export default MobilePhoneButton;
